import { LOCATION_CHANGE } from 'react-router-redux';

const OPEN_MOBILE_NAV = '@@OPEN_MOBILE_NAV';
const CLOSE_MOBILE_NAV = '@@CLOSE_MOBILE_NAV';

const OPEN_SEARCH = '@@OPEN_SEARCH';
const CLOSE_SEARCH = '@@CLOSE_SEARCH';

const OPEN_LOGIN = '@@OPEN_LOGIN';
const CLOSE_LOGIN = '@@CLOSE_LOGIN';

const OPEN_DOWNLOAD = '@@OPEN_DOWNLOAD';
const CLOSE_DOWNLOAD = '@@CLOSE_DOWNLOAD';

const CLOSE_ALL = '@@CLOSE_ALL';

export const openMobileNavigation = () => ({ type: OPEN_MOBILE_NAV });
export const closeMobileNavigation = () => ({ type: CLOSE_MOBILE_NAV });
export const openSearch = () => ({ type: OPEN_SEARCH });
export const closeSearch = () => ({ type: CLOSE_SEARCH });
export const openLogin = () => ({ type: OPEN_LOGIN });
export const closeLogin = () => ({ type: CLOSE_LOGIN });
export const openDownload = () => ({ type: OPEN_DOWNLOAD });
export const closeDownload = () => ({ type: CLOSE_DOWNLOAD });
export const closeAll = () => ({ type: CLOSE_ALL });

const initialState = {
  isMobileNavOpen: false,
  isSearchOpen:    false,
  isLoginOpen:     false,
  isDownloadOpen:  false,
};

export function navigationReducer(
  state = { ...initialState },
  action,
) {
  switch (action.type) {
    case LOCATION_CHANGE:
      return {
        ...initialState
      };
    case CLOSE_ALL:
      return {
        ...initialState
      };
    case OPEN_MOBILE_NAV:
      return {
        ...initialState,
        isMobileNavOpen: true,
      };
    case CLOSE_MOBILE_NAV:
      return {
        ...state,
        isMobileNavOpen: false,
      };
    case OPEN_SEARCH:
      return {
        ...initialState,
        isSearchOpen: true,
      };
    case CLOSE_SEARCH:
      return {
        ...state,
        isSearchOpen: false,
      };
    case OPEN_LOGIN:
      return {
        ...initialState,
        isLoginOpen: true,
      };
    case CLOSE_LOGIN:
      return {
        ...state,
        isLoginOpen: false,
      };
    case OPEN_DOWNLOAD:
      return {
        ...initialState,
        isDownloadOpen:  true,
      };
    case CLOSE_DOWNLOAD:
      return {
        ...state,
        isDownloadOpen: false,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ../src/client/state/navigation.js